import { useEffect } from "react";
import { ga4Service } from "@/services/analytics/ga4Service";

const GTM_CONTAINER_ID = import.meta.env.VITE_GTM_CONTAINER_ID || "GTM-TKW84LSP";

export function AnalyticsBootstrap() {
  useEffect(() => {
    if (!GTM_CONTAINER_ID) {
      console.warn("GTM_CONTAINER_ID not configured");
    }

    ga4Service.initialize();

    const handleConsentChange = () => {
      ga4Service.updateConsent();
    };

    window.addEventListener("cookieConsentChanged", handleConsentChange);

    return () => {
      window.removeEventListener("cookieConsentChanged", handleConsentChange);
    };
  }, []);

  return null;
}
